// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__9lexh","heading":"styles_heading__v76Xj","title":"styles_title__6tZAB","childLink":"styles_childLink__tTlBY"};